<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!permissaoListar">
            <div style="text-align: center">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="permissaoListar">
            <div class="p-fluid p-formgrid grid" *ngIf="permissaoInserir">
                <div class="field col-12 md:col-2">
                    <button
                        pButton
                        pRipple
                        routerLink="/apps/indicador-cliente/inserir"
                        label="Novo"
                        icon="pi pi-plus"
                        class="p-button-outlined sm:w-9rem"
                    ></button>
                </div>
            </div>
            <div class="field col-12 md:col-12">
                <p-messages
                    [(value)]="messages"
                    [enableService]="false"
                    [closable]="true"
                ></p-messages>
            </div>
            <p-table
                #dt1
                [value]="itensPaginados.content"
                dataKey="id"
                [rows]="tamanhoPagina"
                [loading]="loading"
                [rowHover]="true"
                [paginator]="true"
                [totalRecords]="itensPaginados.totalElements"
                [lazy]="true"
                [showCurrentPageReport]="true"
                (onLazyLoad)="onLazyLoad($event)"
                responsiveLayout="stack"
                styleClass=" p-datatable-sm"
                currentPageReportTemplate="Mostrando {first} ao {last} de {totalRecords} registros"
            >
                <ng-template pTemplate="caption">
                    <div class="flex justify-content-end">
                        <div class="p-fluid">
                            <button
                                pButton
                                class="p-button-outlined"
                                icon="pi pi-filter-slash"
                                pTooltip="Limpar Ordernação"
                                tooltipPosition="left"
                                (click)="limpar(dt1)"
                            ></button>
                        </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="dataFluxo">
                            Data
                            <p-sortIcon field="dataFluxo"></p-sortIcon>
                        </th>
                        <th pSortableColumn="identificacao">
                            Identificação
                            <p-sortIcon field="identificacao"></p-sortIcon>
                        </th>
                        <th pSortableColumn="valorFluxo">
                            Valor
                            <p-sortIcon field="valorFluxo"></p-sortIcon>
                        </th>
                        <th style="text-align: center">
                            <div>Ações</div>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                    <tr>
                        <td>
                            {{ item.dataFluxo | date: "dd/MM/yyyy" }}
                        </td>
                        <td>
                            {{ item.identificacao }}
                        </td>
                        <td>
                            {{ item.valorFluxo | currency: "BRL" }}
                        </td>

                        <td style="text-align: center">
                            <div>
                                <button
                                    pButton
                                    pRipple
                                    pTooltip="Direcionar Saída Caixa"
                                    tooltipPosition="bottom"
                                    icon="pi pi-sync"
                                    class="p-button-success"
                                    (click)="abrirDialog(item)"
                                ></button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="7">Nenhum registro encontrado.</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="loadingbody">
                    <tr>
                        <td colspan="7">Carregando grupos. Por favor aguarde.</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
<p-confirmDialog [style]="{ width: '50vw' }"></p-confirmDialog>
<p-dialog
    [(visible)]="exibirDialogAcao"
    [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
    [style]="{ width: '30vw' }"
    [header]="'Direcionar Saída Caixa'"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
>
    <ng-template pTemplate="content">
        <div class="p-fluid p-formgrid grid">
            <div class="field col-12 md:col-6">
                <label class="text-lg font-semibold">Identificação</label>
                <label class="block">
                    {{ saidaSelecionada?.identificacao }}
                </label>
            </div>
            <div class="field col-12 md:col-6">
                <label class="text-lg font-semibold">Valor</label>
                <label class="block">
                    {{ saidaSelecionada?.valorFluxo | currency: "BRL" }}
                </label>
            </div>
            <div class="field col-12">
                <label class="text-lg font-semibold">Conta</label>
                <p-dropdown
                    [options]="listaPlanoContas"
                    optionLabel="descricao"
                    placeholder="Selecione"
                    ngModel
                    [filter]="true"
                    [(ngModel)]="planoContaSelecionado"
                    #conta="ngModel"
                    appendTo="body"
                ></p-dropdown>
                <div
                    *ngIf="!planoContaSelecionado && conta.touched"
                    class="alerta mt-1"
                >
                    <small>Selecione</small>
                </div>
            </div>
        </div>
        <div class="flex justify-content-start mt-3">
            <button
                pButton
                pRipple
                label="Confirmar"
                icon="pi pi-check"
                [icon]="loadingProcessar ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
                class="p-button-outlined w-full md:w-12rem"
                (click)="processar()"
                [disabled]="loadingProcessar || !planoContaSelecionado"
            ></button>
        </div>
    </ng-template>
</p-dialog>
